import { Component, OnInit, inject } from '@angular/core';
import { HrisIntegrationDataService } from '../../services/hris-integration-data.service';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { MatIcon } from '@angular/material/icon';
import { TextButtonComponent } from '../../../../../shared/components/text-button/text-button.component';
import { HrisIntegrationSetupCardComponent } from '../hris-integration-setup-card/hris-integration-setup-card.component';
import { NgClass } from '@angular/common';
import { PrimaryButtonComponent } from '../../../../../shared/components/primary-button/primary-button.component';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'app-hris-integration-card',
  imports: [
    TranslocoPipe,
    MatIcon,
    TextButtonComponent,
    HrisIntegrationSetupCardComponent,
    NgClass,
    PrimaryButtonComponent,
    MatTooltip,
  ],
  templateUrl: './hris-integration-card.component.html',
})
export class HrisIntegrationCardComponent implements OnInit {
  protected readonly hrisIntegrationDataService = inject(
    HrisIntegrationDataService,
  );
  private readonly translocoService = inject(TranslocoService);

  get cardClass(): string {
    if (!this.hrisIntegrationDataService.hrisIntegration) {
      return '';
    }
    switch (this.hrisIntegrationDataService.hrisIntegration.status) {
      case 'active':
        return 'bg-success-light border-success';
      case 'inactive':
        return 'bg-warning-light border-warning';
      case 'error':
        return 'bg-danger-light border-danger';
      default:
        return '';
    }
  }

  get statusClass(): string {
    if (!this.hrisIntegrationDataService.hrisIntegration) {
      return '';
    }
    switch (this.hrisIntegrationDataService.hrisIntegration.status) {
      case 'active':
        return 'text-success';
      case 'inactive':
        return 'text-warning';
      case 'error':
        return 'text-danger';
      default:
        return '';
    }
  }

  get lastSyncedAtTooltip() {
    const dateString =
      this.hrisIntegrationDataService.hrisIntegration?.lastSyncedAt;
    if (dateString) {
      const lang = this.translocoService.getActiveLang();
      const lastSyncedAt = new Date(dateString).toLocaleDateString(
        lang === 'de' ? 'de-DE' : 'en-US',
        {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
          second: 'numeric',
        },
      );
      return this.translocoService.translate(
        'portal.hrisIntegration.card.lastSyncedAtTooltip',
        {
          lastSyncedAt,
        },
      );
    }
    return this.translocoService.translate(
      'portal.hrisIntegration.card.notSyncedYetTooltip',
    );
  }

  onDeleteButtonClick() {
    this.hrisIntegrationDataService.deleteIntegration();
  }

  onSyncNowButtonClick() {
    this.hrisIntegrationDataService.sync();
  }

  onFiltersButtonClick() {
    this.hrisIntegrationDataService.openFiltersDialog();
  }

  ngOnInit() {
    this.hrisIntegrationDataService.init();
  }
}
